/**
 * Zepto save retry (a1210)
 * Before a personalised product goes in the cart, Zepto POSTs the rendered
 * preview to its own server (save_graphql10.php), which creates the hidden
 * variant. When that connection drops (seen on iOS Safari: ring stuck at 25%,
 * then a bare "Add to cart error"), Zepto gives up, leaves the button locked
 * and the customer has to reload the page.
 *
 * This retries that one request quietly when it fails at the network level
 * (status 0) or hangs, and only if every try fails does it unlock Zepto and
 * ask the customer to tap Add to cart again, instead of Zepto's bare alert.
 * Server errors with a real HTTP status are left to Zepto as before.
 *
 * Also (a1210, Drop a Hint): Zepto's 15 Oct 2026 update "parks" anything that
 * sits over its preview image by setting pointer-events:none !important on it
 * (marked data-pplr-cover-off), and re-checks whenever the image scrolls into
 * view. Drop a Hint scrolls to the top and opens its full-screen modal over
 * the image, so Zepto parked the modal and nothing in it could be tapped once
 * a letter was picked. Pop-ups and drawers (fixed, or z-index 1000+) are put
 * back straight away; the marker stays so Zepto doesn't park them again.
 *
 * assets/pplr-save-retry.js
 * <script src="{{ 'pplr-save-retry.js' | asset_url }}" defer></script>
 */
(function () {
  'use strict';
  var SAVE_URL = /zeptoapps\.com\/.*\/save_graphql\d*\.php/i;
  var RETRY_DELAYS = [1000, 2500]; // two retries, so three tries in all
  var TIMEOUT_MS = 60000; // a normal save takes 6-15 s on a phone
  var MESSAGE = "Sorry, that didn't go through. Please tap Add to cart again.";
  var MSG_ID = 'mb-pplr-save-error';

  function log() {
    if (window.console) console.info.apply(console, ['[pplr-retry]'].concat([].slice.call(arguments)));
  }

  function clearMessage() {
    var el = document.getElementById(MSG_ID);
    if (el) el.remove();
  }

  function showMessage() {
    clearMessage();
    var btn = document.querySelector('.pplr_atc_form button.p_a_t_c, .pplr_atc_form [type="submit"], button.p_a_t_c');
    if (!btn) { alert(MESSAGE); return; }
    var el = document.createElement('p');
    el.id = MSG_ID;
    el.setAttribute('role', 'alert');
    el.textContent = MESSAGE;
    el.style.cssText = 'margin:0 0 10px;padding:10px 12px;background:#f5f0e8;color:#8a1c1c;font-size:14px;line-height:1.4;text-align:center;';
    btn.parentNode.insertBefore(el, btn);
    if (el.scrollIntoView) el.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }

  // Put Zepto back to its ready state so the next tap starts a fresh save.
  function unlockZepto() {
    try { if (typeof window.pplr_reset_cart === 'function') window.pplr_reset_cart(); } catch (e) { log('reset failed', e); }
    var $ = window.jQuery;
    if ($) {
      $('.addtocartbg, #p_loading-spinner, #pplr-atc-line').remove();
      $('.p_a_t_c').removeClass('pplr_adding');
      $('.pplr_atc_loading').prop('disabled', false).removeClass('pplr_atc_loading');
    }
  }

  function install($) {
    if (!$ || !$.ajaxPrefilter || $.__mbPplrRetry) return;
    $.__mbPplrRetry = true;
    $.ajaxPrefilter(function (options, originalOptions) {
      if (!SAVE_URL.test(options.url || '')) return;
      var attempt = originalOptions.__mbAttempt || 0;
      var zeptoError = originalOptions.error;
      if (!options.timeout) options.timeout = TIMEOUT_MS;
      if (attempt === 0) clearMessage();
      options.error = function (xhr, status, err) {
        var networkFail = status === 'timeout' || (xhr && xhr.status === 0 && status !== 'abort');
        if (!networkFail) {
          // A real reply from Zepto's server: keep Zepto's own handling.
          if (zeptoError) return zeptoError.apply(this, arguments);
          return;
        }
        if (attempt < RETRY_DELAYS.length) {
          log('save failed (' + status + '), retry ' + (attempt + 1));
          setTimeout(function () {
            $.ajax($.extend({}, originalOptions, { __mbAttempt: attempt + 1 }));
          }, RETRY_DELAYS[attempt]);
          return;
        }
        log('save failed after ' + (attempt + 1) + ' tries (' + status + ')');
        unlockZepto();
        showMessage();
      };
      if (attempt > 0) {
        var zeptoSuccess = originalOptions.success;
        options.success = function () {
          log('save worked on try ' + (attempt + 1));
          if (zeptoSuccess) return zeptoSuccess.apply(this, arguments);
        };
      }
    });
  }

  install(window.jQuery);
  // Zepto can load its own jQuery after this runs, so check again on every
  // tap, before Zepto's own click handler starts the save.
  document.addEventListener('click', function () { install(window.jQuery); }, true);
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.p_a_t_c')) clearMessage();
  }, true);

  // Undo Zepto's parking for pop-ups and drawers (see the note at the top).
  function isOverlay(el) {
    for (var n = el; n && n.nodeType === 1 && n !== document.body; n = n.parentElement) {
      if (n.id && /^dropahint/i.test(n.id)) return true;
      var cs = getComputedStyle(n);
      if (cs.position === 'fixed') return true;
      if (cs.position !== 'static' && parseInt(cs.zIndex, 10) >= 1000) return true;
    }
    return false;
  }

  function unpark(el) {
    if (!el.hasAttribute('data-pplr-cover-off') || !isOverlay(el)) return;
    var saved = el.getAttribute('data-pplr-cover-off');
    el.style.removeProperty('pointer-events');
    if (saved) el.style.setProperty('pointer-events', saved);
  }

  if (window.MutationObserver) {
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) unpark(records[i].target);
    }).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['data-pplr-cover-off'] });
  }
})();
